import { action, computed, observable } from 'mobx';
import { LoadingTarget } from '../models/loading';
import { BaseStore } from './BaseStore';
import { generateGuid } from '../utils/generateGuid';
export type TTargets = { [target in LoadingTarget]?: Array<string> };

export class LoadingStore extends BaseStore {
    @observable targets: TTargets = {};
    @observable loadingCache: { [target in LoadingTarget]?: boolean } = {};

    @observable isGlobalLoading: boolean = false;
    @observable isFundsMoreLoading: boolean = false;
    @observable isExplorerDownloadLoading: boolean = false;
    @action
    start(target: LoadingTarget, id?: string) {
        if (!id) {
            id = this.getLoadingId();
        }
        if (!this.targets) {
            this.targets = {};
        }
        if (!this.targets[target]) {
            this.targets[target] = observable([]);
        }
        this.targets[target].push(id);
        this.refreshCache();
        return id;
    }
    @action
    stop(target: LoadingTarget, id: string) {
        if (this.targets && this.targets[target]) {
            this.targets[target] = this.targets[target].filter(
                targetId => targetId !== id
            );
        }
        this.loadingCache[target] = !!(
            this.targets[target] && this.targets[target].length > 0
        );
        this.refreshCache();
    }
    @action
    refreshCache() {
        this.isGlobalLoading =
            this.targets.global && this.targets.global.length > 0;
        this.isFundsMoreLoading =
            this.targets.funds_more && this.targets.funds_more.length > 0;
        this.isExplorerDownloadLoading =
            this.targets.explorer_download &&
            this.targets.explorer_download.length > 0;
    }
    checkLoading(target: Array<string>) {
        return target && target.length > 0;
    }
    getLoadingId() {
        return generateGuid();
    }
    @computed
    get global() {
        return this.isGlobalLoading;
    }
    @computed
    get fundsMore() {
        return this.isFundsMoreLoading;
    }
    @computed
    get explorerDownload() {
        return this.isExplorerDownloadLoading;
    }
}



// WEBPACK FOOTER //
// ./src/stores/LoadingStore.ts